import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Card = ({ className, children, innerClassName, title, desc, style }) => (
  <div className={`${styles.card} ${className}`} role="region" style={style}>
    <div
      className={innerClassName === '' ? styles.card__inner : innerClassName}
    >
      {title ? (
        <div>
          <h2>{title}</h2>
          <div className="subheading">{desc}</div>
        </div>
      ) : null}
      {children}
    </div>
  </div>
);

Card.defaultProps = {
  className: '',
  innerClassName: '',
};

Card.propTypes = {
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  title: PropTypes.string,
  desc: PropTypes.string,
  style: PropTypes.object,
};

export default Card;
